import React, { useEffect, useState } from "react";
import { useGuidedTour } from "@/lib/guidedTour";
import { useNarrationCue } from "@/components/clientDemo/tour/TourCuePointer";
import { EarningsCard, PlacementCard, PreCertCard, RosterCard } from "./CareerCards";

export const CAREER_CUES = [
  { phrase: "pre-certified", target: "exchange-career-card-precert" },
  { phrase: "Career destinations", target: "exchange-career-card-placement" },
  { phrase: "live roster", target: "exchange-career-card-roster" },
  { phrase: "own earnings", target: "exchange-career-card-earnings" },
];
const CARDS = [PreCertCard, PlacementCard, RosterCard, EarningsCard];

// Beat 05 — Employment & Sprint to Career; each card replays when the narration names it.
export default function ExchangeCareerSection() {
  const { isActive, current } = useGuidedTour();
  const live = isActive && current?.id === "beat05";
  const cue = useNarrationCue(CAREER_CUES.map((c) => c.phrase), live);
  const [runs, setRuns] = useState([0, 0, 0, 0]);
  useEffect(() => {
    if (cue >= 0) setRuns((r) => r.map((n, i) => (i === cue ? n + 1 : n)));
  }, [cue]);

  return (
    <section data-testid="exchange-career-section" className="mt-8 rounded-3xl border border-[#D4AF37]/20 bg-[#0A0612] p-6 md:p-8">
      <div className="mb-6">
        <div className="font-mono text-[10px] tracking-[0.28em] uppercase text-[#C9A227]">// 08 · Career</div>
        <h2 className="mt-1 text-2xl md:text-3xl font-extrabold tracking-tight text-white">Employment &amp; Sprint to Career</h2>
      </div>
      <div className="flex gap-6">
        <div className="flex-1 min-w-0 grid grid-cols-1 md:grid-cols-2 gap-4">
          {CARDS.map((Card, i) => <Card key={i} run={runs[i]} active={live && cue === i} />)}
        </div>
        <aside data-testid="exchange-career-dock" className="hidden xl:flex w-[440px] shrink-0 rounded-2xl border border-dashed border-[#D4AF37]/25 bg-[#D4AF37]/[0.03] p-6 flex-col justify-center">
          <div className="font-mono text-[10px] tracking-[0.24em] uppercase text-[#C9A227]">From Work-Ready to wages</div>
          <ul className="mt-4 space-y-3 text-sm text-slate-300">
            {["Pre-certified before day one", "Four career tracks, real employers", "One live roster for every employer", "Earnings, rent and savings, shift by shift"].map((t) => (
              <li key={t} className="flex items-start gap-2"><span className="mt-1.5 h-1.5 w-1.5 rounded-full bg-[#D4AF37] shrink-0" />{t}</li>
            ))}
          </ul>
        </aside>
      </div>
    </section>
  );
}
